// X1 route cleanup (wayfinder tickets/04-deletion-list.md, approved 2026-09-03).
/** Historical record only: when the X1 routes were retired. Nothing reads this to expire a redirect. */
export const ROUTE_RETIREMENT_DATE = '2026-09-03';

// Retired-route redirects are permanent (decided 2026-10-05, ClickUp 86e3a6zrj). Old links in emails, decks and
// DMs keep landing on the merged screen. A route is removed only by a PR that deletes its <Route>
// after the `route.retired_redirect` event shows 30 days of zero hits for it.

/**
 * Replaces each route-param value in a pathname with its `:name` placeholder (a splat tail with `*`),
 * so telemetry never carries a codename, id or token. Matches whole decoded segments only, so a value
 * that happens to prefix another segment (`/deal/a/assets`) cannot corrupt or leak through it.
 */
export function redactPathParams(pathname: string, params: Record<string, string | undefined>): string {
  const splat = params['*'];
  let path = pathname;
  if (splat) {
    const at = path.lastIndexOf(`/${splat}`);
    if (at >= 0) path = `${path.slice(0, at)}/*`;
  }
  const nameByValue = new Map<string, string>();
  for (const [name, value] of Object.entries(params)) {
    if (value && name !== '*') nameByValue.set(value, name);
  }
  return path
    .split('/')
    .map((segment) => {
      let decoded = segment;
      try {
        decoded = decodeURIComponent(segment);
      } catch {
        // Malformed escape: compare the raw segment.
      }
      const name = nameByValue.get(decoded) ?? nameByValue.get(segment);
      return name ? `:${name}` : segment;
    })
    .join('/');
}

export function parkedRoutesEnabled(): boolean {
  return import.meta.env.VITE_PARKED_ROUTES_ENABLED === 'true';
}

/** Substitutes `:param` placeholders in a redirect target from the current route params. */
export function fillRouteParams(target: string, params: Record<string, string | undefined>): string {
  return target.replace(/:(\w+)/g, (_m, name: string) => encodeURIComponent(params[name] ?? ''));
}
